import RegisterScreen from './register-screen';

export default RegisterScreen;
